import { mapBaseURL } from "@/constants";
import { MarinePortsResponse } from "@/features/survey/types";
import { useEffect, useState } from "react";

// Custom fetch-based hook to replace RTK Query
export const useFetchMarinePortsQuery = () => {
  const [data, setData] = useState<MarinePortsResponse | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isCancelled = false;

    const fetchMarinePorts = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        setError(null);

        const response = await fetch(
          `${mapBaseURL}GeoJson/Principal_Ports.geojson`,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const marinePortsData: MarinePortsResponse = await response.json();

        if (!isCancelled) {
          setData(marinePortsData);
        }
      } catch (err) {
        if (!isCancelled) {
          setIsError(true);
          setError(
            err instanceof Error ? err : new Error("Unknown error occurred"),
          );
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchMarinePorts();

    return () => {
      isCancelled = true;
    };
  }, []);

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
